/* esm.sh - nostr-tools@2.23.3/nip49 */
export * from "/*nostr-tools@2.23.3/esnext/nip49.mjs";
